import Vue from 'vue'
import store from '~/store'
import router from '~/router'
import { i18n } from '~/plugins'
import vuetify from './plugins/vuetify'
import App from '~/components/App'
import '~/components'
import excel from 'vue-excel-export'
import VueMoment from 'vue-moment'
import VueClipboard from 'vue-clipboard2'
// import '~/assets/sass/app.scss'
import 'vuetify-dialog/dist/vuetify-dialog.css'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
import 'leaflet/dist/leaflet.css'
import VuetifyDialog from 'vuetify-dialog'

Vue.use(VuetifyDialog)

window._ = require('lodash')

Vue.config.productionTip = false

Vue.use(Viewer)
Vue.use(excel)
Vue.use(VueMoment)
Vue.use(VueClipboard)

Vue.use(TiptapVuetifyPlugin, {
  iconsGroup: 'mdi'
})

new Vue({
  el: '#app',
  i18n,
  vuetify,
  store,
  router,
  ...App
})



// WEBPACK FOOTER //
// ./resources/assets/js/app.js